module.exports = __webpack_public_path__ + "img/cart_menu_hover.8754afb9.svg";